import redirects from '../data/redirects';

export default defineNuxtRouteMiddleware((to) => {
    const redirectUrl = redirects[to.path];

    if (redirectUrl) {
        return navigateTo(redirectUrl);
    }
});
